import badge_apple from './svg/badge_apple.svg';
import badge_apple_outline from './svg/badge_apple_outline.svg';
import badge_apple_outline_light from './svg/badge_apple_outline_light.svg';
import badge_google from './svg/badge_google.svg';
import badge_google_outline from './svg/badge_google_outline.svg';
import badge_google_outline_light from './svg/badge_google_outline_light.svg';
import bg_giftcard_bikeit from './svg/bg_giftcard_bikeit.svg';
import bg_giftcard_cervinia from './svg/bg_giftcard_cervinia.svg';
import bg_giftcard_discovera from './svg/bg_giftcard_discovera.svg';
import bg_giftcard_snowit from './svg/bg_giftcard_snowit.svg';
import bg_giftcard_tribala from './svg/bg_giftcard_tribala.svg';
import bike_img_cart_empty from './svg/bike_img_cart_empty.svg';
import bike_img_choose_gear from './svg/bike_img_choose_gear.svg';
import bike_img_config_trip from './svg/bike_img_config_trip.svg';
import bike_img_go from './svg/bike_img_go.svg';
import bike_img_not_found from './svg/bike_img_not_found.svg';
import bike_img_ok from './svg/bike_img_ok.svg';
import bike_img_search_trip from './svg/bike_img_search_trip.svg';
import img_accept_policy from './svg/img_accept_policy.svg';
import img_active_skipass from './svg/img_active_skipass.svg';
import img_app_download from './svg/img_app_download.svg';
import img_art from './svg/img_art.svg';
import img_bracelet_active from './svg/img_bracelet_active.svg';
import img_bracelet_number_zoom from './svg/img_bracelet_number_zoom.svg';
import img_bracelet_pay from './svg/img_bracelet_pay.svg';
import img_bracelet_qr from './svg/img_bracelet_qr.svg';
import img_bracelet_skipass from './svg/img_bracelet_skipass.svg';
import img_bracelet_steps from './svg/img_bracelet_steps.svg';
import img_bracelet_tapster_app from './svg/img_bracelet_tapster_app.svg';
import img_calendar_range from './svg/img_calendar_range.svg';
import img_card_number_zoom from './svg/img_card_number_zoom.svg';
import img_cart_add from './svg/img_cart_add.svg';
import img_cart_empty from './svg/img_cart_empty.svg';
import img_choose_gear from './svg/img_choose_gear.svg';
import img_choose_lesson from './svg/img_choose_lesson.svg';
import img_choose_option from './svg/img_choose_option.svg';
import img_choose_snowitcard from './svg/img_choose_snowitcard.svg';
import img_complete_info from './svg/img_complete_info.svg';
import img_email_code from './svg/img_email_code.svg';
import img_error_bike from './svg/img_error_bike.svg';
import img_error_kitesurf from './svg/img_error_kitesurf.svg';
import img_error_train from './svg/img_error_train.svg';
import img_fly_ticket from './svg/img_fly_ticket.svg';
import img_friend_discount from './svg/img_friend_discount.svg';
import img_go_ski from './svg/img_go_ski.svg';
import img_hotel_options_search from './svg/img_hotel_options_search.svg';
import img_hotel_skipass from './svg/img_hotel_skipass.svg';
import img_insert_coupon from './svg/img_insert_coupon.svg';
import img_insurance from './svg/img_insurance.svg';
import img_insurance_snowcare from './svg/img_insurance_snowcare.svg';
import img_item_search from './svg/img_item_search.svg';
import img_item_select from './svg/img_item_select.svg';
import img_location_info from './svg/img_location_info.svg';
import img_location_select from './svg/img_location_select.svg';
import img_lombardia from './svg/img_lombardia.svg';
import img_love from './svg/img_love.svg';
import img_meet_instructor from './svg/img_meet_instructor.svg';
import img_music from './svg/img_music.svg';
import img_newsletter from './svg/img_newsletter.svg';
import img_not_result from './svg/img_not_result.svg';
import img_notification from './svg/img_notification.svg';
import img_pay_authorization from './svg/img_pay_authorization.svg';
import img_pay_per_use from './svg/img_pay_per_use.svg';
import img_payment_calc from './svg/img_payment_calc.svg';
import img_payment_invoice from './svg/img_payment_invoice.svg';
import img_performance from './svg/img_performance.svg';
import img_pickup_gear from './svg/img_pickup_gear.svg';
import img_pickup_skipass from './svg/img_pickup_skipass.svg';
import img_placeholder from './svg/img_placeholder.svg';
import img_plastic_free from './svg/img_plastic_free.svg';
import img_price_chart from './svg/img_price_chart.svg';
import img_privacy from './svg/img_privacy.svg';
import img_profile from './svg/img_profile.svg';
import img_profile_add from './svg/img_profile_add.svg';
import img_profile_complete from './svg/img_profile_complete.svg';
import img_program_travel from './svg/img_program_travel.svg';
import img_promo from './svg/img_promo.svg';
import img_rental from './svg/img_rental.svg';
import img_save from './svg/img_save.svg';
import img_security from './svg/img_security.svg';
import img_ski_pay_later from './svg/img_ski_pay_later.svg';
import img_ski_season from './svg/img_ski_season.svg';
import img_ski_track from './svg/img_ski_track.svg';
import img_skip_queue from './svg/img_skip_queue.svg';
import img_skipass from './svg/img_skipass.svg';
import img_skipass_nfc from './svg/img_skipass_nfc.svg';
import img_skipass_phone from './svg/img_skipass_phone.svg';
import img_snowcoins from './svg/img_snowcoins.svg';
import img_snowman from './svg/img_snowman.svg';
import img_snowman_error from './svg/img_snowman_error.svg';
import img_success from './svg/img_success.svg';
import img_train_travel from './svg/img_train_travel.svg';
import img_transitions_list from './svg/img_transitions_list.svg';
import img_tribe from './svg/img_tribe.svg';
import img_upload_document from './svg/img_upload_document.svg';
import img_upload_success from './svg/img_upload_success.svg';
import img_view_coupon from './svg/img_view_coupon.svg';
import img_welcome_panel from './svg/img_welcome_panel.svg';
import snowitcard_basic_front from './svg/snowitcard_basic_front.svg';
import snowitcard_limited_front from './svg/snowitcard_limited_front.svg';

const svgs = {
  badge_apple,
  badge_apple_outline,
  badge_apple_outline_light,
  badge_google,
  badge_google_outline,
  badge_google_outline_light,
  bg_giftcard_bikeit,
  bg_giftcard_discovera,
  bg_giftcard_tribala,
  bg_giftcard_cervinia,
  bg_giftcard_snowit,
  bike_img_cart_empty,
  bike_img_choose_gear,
  bike_img_config_trip,
  bike_img_go,
  bike_img_not_found,
  bike_img_ok,
  bike_img_search_trip,
  img_accept_policy,
  img_active_skipass,
  img_app_download,
  img_art,
  img_bracelet_active,
  img_bracelet_number_zoom,
  img_bracelet_pay,
  img_bracelet_qr,
  img_bracelet_skipass,
  img_bracelet_steps,
  img_bracelet_tapster_app,
  img_buy_skipass: img_item_select,
  img_calendar_range,
  img_card_number_zoom,
  img_cart_add,
  img_cart_empty,
  img_choose_gear,
  img_choose_lesson,
  img_choose_option,
  img_choose_snowitcard,
  img_complete_info,
  img_email_code,
  img_error_bike,
  img_error_kitesurf,
  img_error_not_result: img_not_result,
  img_error_snowman: img_snowman_error,
  img_error_train,
  img_fly_ticket,
  img_friend_discount,
  img_go_ski,
  img_hotel_options_search,
  img_hotel_skipass,
  img_insert_coupon,
  img_insurance,
  img_insurance_snowcare,
  img_item_search,
  img_item_select,
  img_location_info,
  img_location_select,
  img_lombardia,
  img_love,
  img_meet_instructor,
  img_music,
  img_newsletter,
  img_not_result,
  img_notification,
  img_pay_authorization,
  img_pay_per_use,
  img_payment_calc,
  img_payment_invoice,
  img_performance,
  img_pickup_gear,
  img_pickup_skipass,
  img_placeholder,
  img_plastic_free,
  img_price_chart,
  img_privacy,
  img_profile,
  img_profile_add,
  img_profile_complete,
  img_program_travel,
  img_promo,
  img_rental,
  img_save,
  img_security,
  img_ski_pay_later,
  img_ski_season,
  img_ski_track,
  img_skip_queue,
  img_skipass,
  img_skipass_nfc,
  img_skipass_phone,
  img_snowcoins,
  img_snowman,
  img_snowman_error,
  img_success,
  img_train_travel,
  img_transitions_list,
  img_tribe,
  img_upload_document,
  img_upload_success,
  img_view_coupon,
  img_welcome_panel,
  snowitcard_basic_front,
  snowitcard_limited_front,
} as const;

export type SvgImagesList = keyof typeof svgs;
export default svgs;
